// components
import {
  ProfileDetailsWidgetDesktop,
  ProfileDetailsWidgetMobile,
} from "./index"

export const ProfileDetailsWidget = ({ isMobile = false, data }) => {
  const profileDetails = data
  const getCreatedAt = () => {
    if (profileDetails?.created_at) {
      return new Date(profileDetails?.created_at).toLocaleDateString()
    }
  }

  // Process disorders
  const activeDisorders =
    profileDetails?.local?.diagnosed?.filter((d) => !d.isDeleted) || []
  const primaryDisorder =
    activeDisorders.length > 0 ? activeDisorders[0].name : "None"
  const disorderNames = activeDisorders.map((d) => d.name)

  const widgetData = profileDetails
    ? {
        email: profileDetails.local.email,
        contact: profileDetails.local.contact,
        location: `${profileDetails.local.province}, ${profileDetails.local.country}`,
        "Reference Number": profileDetails.referenceNumber,
        createdAt: getCreatedAt(),
        disorder: primaryDisorder,
        eye: profileDetails.local.eye,
        address: profileDetails.local.address,
        allDisorders: disorderNames,
      }
    : {
        email: "",
        contact: "",
        location: "",
        pincode: "",
        eye: "",
        "Reference Number": "",
        address: "",
        createdAt: "",
        disorder: "",
        allDisorders: [],
      }
  const fullName = profileDetails
    ? `${profileDetails.local.firstName} ${profileDetails.local.lastName}`
    : "dawn lee"
  return (
    <>
      {isMobile ? (
        <ProfileDetailsWidgetMobile
          widgetData={widgetData}
          fullName={fullName}
        />
      ) : (
        <ProfileDetailsWidgetDesktop
          widgetData={widgetData}
          fullName={fullName}
        />
      )}
    </>
  )
}
